// extracted by css-extract-rspack-plugin
export default {"fillTextPrimary":"fillTextPrimary__RCvoR","fillBackgroundPrimary":"fillBackgroundPrimary__Jqg0h"};